<template>
  <div class="tw:grid tw:grid-cols-[24px_1fr] tw:gap-2 tw:rounded-lg tw:border tw:border-red-300 tw:bg-red-200 tw:p-3">
    <TriangleWarningColors class="tw:size-6 tw:shrink-0 tw:self-start tw:fill-none" aria-hidden="true" />
    <div>
      <p class="tw:text-sm tw:font-bold">{{ $t('description_error_header') }}</p>
      <ul class="tw:text-sm">
        <li v-for="errorKey in errorKeys" :key="errorKey">
          {{ $t(errorKey) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import TriangleWarningColors from '@/components/icons/TriangleWarningColors.svg?component'

const errorKeys = ['description_error_1', 'description_error_2', 'description_error_3', 'description_error_4']
</script>
